import { render } from "./SkeletonCard.vue?vue&type=template&id=01a08ea2&ts=true"
import script from "./SkeletonCard.vue?vue&type=script&lang=ts"
export * from "./SkeletonCard.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__